import React from "react";
import AddEnquiresHome from "./components/AddEnquiresHome";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";

const AddEnquires = () => {
  return (
    <>
      <Sidebar />
      <MainSection>
        <AddEnquiresHome />
      </MainSection>
    </>
  );
};

export default AddEnquires;
